const NAME = 'market-data';

export default NAME;
